import { AppState } from '../../../types'
import { CustomMetric, CustomMetricSelector, customMetricSelectorInitialState } from './model'
import { buildCustomMetricsKey } from './CustomMetricRow/util/GraphService'

const selectors = {
  getAll: (state: AppState) => state.monitoring.customMetrics,
  isLoadingMetrics: (state: AppState) => selectors.getAll(state).metricList.isLoading,
  metrics: (state: AppState) => selectors.getAll(state).metricList.metrics,
  metric: (metricName: string, state: AppState): CustomMetric | undefined => {
    const metrics = selectors.metrics(state)
    if (metrics) {
      return metrics.find(metric => metric.name === metricName)
    } else {
      return undefined
    }
  },
  selector: (metricName: string, state: AppState): CustomMetricSelector => {
    const metric = selectors.metric(metricName, state)
    if (metric) {
      return metric.selector
    } else {
      return {...customMetricSelectorInitialState}
    }
  },
  selectedEnvironment: (state: AppState) => state.monitoring.builtIn.environmentSelector.selected,
  orgId: (state: AppState) => state.monitoring.auth.profile.organizationId,
  envId: (state: AppState) => state.monitoring.resources.environments.selected,
  appId: (state: AppState) => state.monitoring.resources.applications.selected,
  customMetricsKey: (state: AppState) => {
    const metrics = selectors.getAll(state).metricList.metrics

    return metrics ? buildCustomMetricsKey(metrics) : ''
  }
}

export default selectors
